// extracted by mini-css-extract-plugin
export default {"tabContainer":"style_tabContainer__TYBs+","tabItem":"style_tabItem__A8JdU","active":"style_active__ctzJt","divider":"style_divider__JaKpM"};